// extracted by mini-css-extract-plugin
export var copyIcon = "_so-2";
export var discountCard = "_so-0";
export var discountCode = "_so-3";
export var discountContent = "_so-1";
export var loadingCard = "_so-4";